module.exports = "<div class=\"search-box\">\r\n    <input [(ngModel)]=\"searchInput\" \r\n           (keyup.enter)=\"onEnter()\"\r\n           class=\"search-box-input\" type=\"text\" \r\n           placeholder=\"search data dictionary\"\r\n           />  \r\n    <button class=\"search-box-button\"\r\n       [routerLink]=\"['/search']\"\r\n       [queryParams]=\"{q:searchInput}\">Go</button>\r\n</div>\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/shared/search-box/search-box.component.html
// module id = ./src/app/shared/search-box/search-box.component.html
// module chunks = main